import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';

import {serverAlertRuleAPI} from 'features/server/api/serverAlertRuleAPI';
import {fetchMe} from 'entities/user';
import {TypedDispatch} from 'shared/model/types';

import IServerAlertRule from './ServerAlertRule/IServerAlertRule';

interface IDeleteParams {
    uuid: string,
    handleClose: () => void,
}

export const useServerAlertRuleDelete = ({uuid, handleClose}: IDeleteParams) => {
    const [deleteServerAlertRule, {isLoading}] = serverAlertRuleAPI.useDeleteServerAlertRuleMutation();
    const dispatch = useDispatch<TypedDispatch>();

    const remove = useCallback(async() => {
        await deleteServerAlertRule(uuid).unwrap();
        toast.info(t`Правило удалено`);
        dispatch(fetchMe());
        handleClose();
    }, [deleteServerAlertRule, uuid, dispatch, handleClose]);

    return {remove, isLoading};
};

export const useServerAlertRuleToggle = (item: IServerAlertRule) => {
    const [updateServerAlertRule] = serverAlertRuleAPI.useUpdateServerAlertRuleMutation();

    const toggle = useCallback(async() => {
        await updateServerAlertRule({
            uuid: item.uuid,
            server: item.server,
            metric: item.metric,
            scope: item.scope,
            operator: item.operator,
            threshold: item.threshold,
            for_seconds: item.for_seconds,
            recover_seconds: item.recover_seconds,
            severity: item.severity,
            enabled: !item.enabled,
        }).unwrap();
        toast.info(item.enabled ? t`Правило выключено` : t`Правило включено`);
    }, [updateServerAlertRule, item]);

    return {toggle};
};
